import * as constants from './constants';

const initial = {
  details: null,
  error: null,
  isDocDetailsRequestPending: false,
};

export default function documentsReducer(state = initial, action = {}) {
  switch (action.type) {
    case constants.REQUEST_DOCUMENT_DETAILS:
      return {
        ...state,
        details: null,
        error: null,
        isDocDetailsRequestPending: true,
      };

    case constants.REQUEST_DOCUMENT_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.details,
        error: null,
        isDocDetailsRequestPending: false,
      };

    case constants.REQUEST_DOCUMENT_DETAILS_FAIL:
      return {
        ...state,
        details: null,
        error: action.error,
        isDocDetailsRequestPending: false,
      };

    case constants.RESET_STATE:
      return {...initial};

    default:
      return state;
  }
}
